import React, { useState, useEffect } from "react";
import { Row, InputGroup, Button, Table } from "react-bootstrap";
import { CCol, CFormLabel } from "@coreui/react";
import PageWrapper from "../../../pagecomponents/Common/PageWrapper";
import { number_format } from "../../../helpers/utility";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { useDispatch } from "react-redux";
import { getBsData } from "../../../redux/slices/ReportSlice";

const LIST_PARAMS = {
    fromdate: format(new Date(new Date().setFullYear(new Date().getFullYear() - 1)), "yyyy-MM-dd"),
    todate: format(new Date(), "yyyy-MM-dd")
};

const BalanceSheetIndex = () => {
    const dispatch = useDispatch();
    const [params, setParams] = useState(LIST_PARAMS);
    const [data, setData] = useState([]);

    useEffect(()=> {
        getComponentData();
    }, [params]);

    const getComponentData = async() => {
        try {
            const { payload } = await dispatch(getBsData({ inputData: params }));
            console.log(payload);
            
            setData(payload);
            // setTotalPage(Math.ceil(payload?.count/rowsPerPage)); 
        } catch (err) {
            // toastMessage("error", "Failed to fetch data");
        } finally {
            // setIsLoading(false); // Stop loader
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Prevent invalid date formatting
        if (!value) return;

        setParams((prevParams) => ({
            ...prevParams,
            [name]: format(new Date(value), "yyyy-MM-dd") // Ensuring date format
        }));
    };

    const handleAmountFormat = (amount) => {
        return number_format(amount,2);
    };

    return(
        <PageWrapper pageName={"Balance Sheet"}>
            <Row className="row-xs mb-4">      
                <CCol md={3}>
                    <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="fromdate">From Date</CFormLabel>
                    <InputGroup className="input-group reactdate-pic">
                        <InputGroup.Text className="input-group-text">
                            <i className="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
                        </InputGroup.Text>
                        <DatePicker
                            className="form-control"
                            name="fromdate"
                            id="fromdate"
                            selected={params.fromdate ? new Date(params.fromdate) : null} // Convert to Date object
                            onChange={(date) => {
                                const event = {
                                    target: {
                                        name: "fromdate",
                                        value: date,
                                    },
                                };
                                handleInputChange(event); // Simulate an event for compatibility
                            }}
                            dateFormat="yyyy-MM-dd" // Match the desired format
                            // isClearable // Optional: Allow clearing the date
                        />
                    </InputGroup>
                </CCol>
                <CCol md={3}>
                    <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="todate">To Date</CFormLabel>
                    <InputGroup className="input-group reactdate-pic">
                        <InputGroup.Text className="input-group-text">
                            <i className="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
                        </InputGroup.Text>
                        <DatePicker
                            className="form-control"
                            name="todate"
                            id="todate"
                            selected={params.todate ? new Date(params.todate) : null} // Convert to Date object
                            onChange={(date) => {
                                const event = {
                                    target: {
                                        name: "todate",
                                        value: date,
                                    },
                                };
                                handleInputChange(event); // Simulate an event for compatibility
                            }}
                            dateFormat="yyyy-MM-dd" // Match the desired format
                            // isClearable // Optional: Allow clearing the date
                        />
                    </InputGroup>
                </CCol>
            </Row>

            <Table className="text-nowrap mb-0">
                <thead>
                    <tr className="border-bottom border-top">
                        <th className="w-40">Liabilities</th>
                        <th className="w-10 text-right">Amount</th>
                        <th className="w-40">Assets</th>
                        <th className="w-10 text-right">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {/* <tr className="cursor-pointer">
                        <td className="pb-0">Capital Account</td>
                        <td className="pb-0 text-right">{handleAmountFormat(0)}</td>
                        <td className="pb-0">Fixed Assets</td>
                        <td className="pb-0 text-right">{handleAmountFormat(0)}</td>
                    </tr>
                    <tr className="cursor-pointer">
                        <td className="pb-0">Reserves & Surplus</td>
                        <td className="pb-0 text-right">{handleAmountFormat(0)}</td>
                        <td className="pb-0">Current Assets</td>
                        <td className="pb-0 text-right">{handleAmountFormat(0)}</td>
                    </tr> */}
                    <tr className="cursor-pointer">
                        <td className="pb-0">Sundry Creditors</td>
                        <td className="pb-0 text-right">{handleAmountFormat(data.sundry_creditors)}</td>
                        <td className="pb-0">Cash-in-Hand</td>
                        <td className="pb-0 text-right">{handleAmountFormat(data.cash_in_hand)}</td>
                    </tr>
                    <tr className="cursor-pointer">
                        <td className="pb-0">{/*Loan Accounts*/}</td>
                        <td className="pb-0 text-right"></td>
                        <td className="pb-0">Bank Accounts</td>
                        <td className="pb-0 text-right">{handleAmountFormat(data.bank_account)}</td>
                    </tr>
                    <tr className="cursor-pointer">
                        <td className="pb-0">{/*Outstanding Expenses*/}</td>
                        <td className="pb-0 text-right"></td>
                        <td className="pb-0">Sundry Debtors</td>
                        <td className="pb-0 text-right">{handleAmountFormat(data.sundry_debtors)}</td>
                    </tr>
                    {/* <tr className="cursor-pointer">
                        <td className="pb-0">Duties & Taxes</td>
                        <td className="pb-0 text-right">{handleAmountFormat(0)}</td>
                        <td className="pb-0">Investments</td>
                        <td className="pb-0 text-right">{handleAmountFormat(0)}</td>
                    </tr>
                    <tr className="cursor-pointer">
                        <td className=""></td>
                        <td className=" text-right"></td>
                        <td className="">Advances (Assets)</td>
                        <td className=" text-right">{handleAmountFormat(0)}</td>
                    </tr> */}
                    <tr className="cursor-pointer">
                        <td className=" border-top border-bottom"></td>
                        <td className=" text-right border-top border-bottom">{handleAmountFormat(data.liability_total)}</td>
                        <td className=" border-top border-bottom"></td>
                        <td className=" text-right border-top border-bottom">{handleAmountFormat(data.asset_total)}</td>
                    </tr>
                </tbody>
            </Table>
        </PageWrapper>
    );
};

export default BalanceSheetIndex;